import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class LaborContractRenewalApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'labor-contract-renewal'
  }

}